export interface Result {
	category: string;
	isSuccess: boolean;
	error?: Error;
}

export const SuccessfulCategory = "Successful";
export const ErrorCategory = "Error";

export const success = (category: string): Result => {
	category = category || SuccessfulCategory;
	return { isSuccess: true, category };
};

export const failure = (category: string, error?: Error): Result => ({
	isSuccess: false,
	category,
	error
});
